/**
 * Formats the unit price inside the add-to-cart banner.
 * Issue is that empire.js fills the banner straight from the cart API, which reports default theme units.
 * That bundle is a build artefact from original theme creator that we don't want to touch.
 * Therefore this js is to go inbetween.
 */
(function () {
  if (window.wbnAtcBannerUnitPrice) {
    return;
  }
  window.wbnAtcBannerUnitPrice = true;

  // product-price.liquid skips the unit price for these units
  var HIDDEN_UNITS = ['m'];

  function splitValueAndUnit(text) {
    var match = /^\s*([\d.,]*)\s*(\S[\s\S]*?)\s*$/.exec(text || '');
    return match ? { value: match[1], unit: match[2] } : null;
  }

  function formatQuantity(value, separator) {
    var rounded = Math.round(parseFloat(value));
    if (!isFinite(rounded)) {
      return value;
    }
    return String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  // a unit without a `general.units.*` entry keeps the raw value from the API.
  function unitLabel(container, unit) {
    return container.getAttribute('data-wbn-unit-' + unit) || unit;
  }

  function format(container) {
    // The original template in [data-templates] still holds the placeholders
    if (container.innerHTML.indexOf('**') !== -1) {
      return;
    }

    var separator = container.getAttribute('data-wbn-thousands-separator') || '.';
    var quantity = container.querySelector('[data-wbn-atc-quantity]');
    var measure = container.querySelector('[data-wbn-atc-measure]');

    if (quantity) {
      var parsedQuantity = splitValueAndUnit(quantity.textContent);
      if (parsedQuantity) {
        if (HIDDEN_UNITS.indexOf(parsedQuantity.unit) !== -1) {
          container.classList.add('hidden');
          return;
        }
        quantity.textContent =
          formatQuantity(parsedQuantity.value, separator) + '\u00a0' + unitLabel(container, parsedQuantity.unit);
      }
    }

    if (measure) {
      var parsedMeasure = splitValueAndUnit(measure.textContent);
      if (parsedMeasure) {
        var label = unitLabel(container, parsedMeasure.unit);
        measure.textContent = parsedMeasure.value ? parsedMeasure.value + '\u00a0' + label : label;
      }
    }
  }

  window.addEventListener('cartcount:update', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-atc-banner-unit-price]'), format);
  });
})();
